import { useAccount, useReadContract } from 'wagmi';
import { erc20Abi } from 'viem';
import useAppStore from '../../../store/rootStore';
import { AUSD_ADDRESS } from '../../../providers/fun_bridge/constants';
import { monad } from 'viem/chains';

export function useBridgeAlertState() {
  const { address } = useAccount();
  const isAuth = useAppStore((state) => state.isAtLeastAuthenticated());
  const funBridgeEnabled = useAppStore((state) => !!state.config?.features?.funBridgeEnabled);
  const isWalletDataLoaded = useAppStore((state) => state.walletData != null);
  const hasNoExchangeBalance = useAppStore((state) => BigInt(state.account?.b || 0) === 0n);

  const { data: ausdBalance } = useReadContract({
    address: AUSD_ADDRESS as `0x${string}`,
    abi: erc20Abi,
    functionName: 'balanceOf',
    args: address ? [address] : undefined,
    chainId: monad.id,
    query: {
      enabled: !!address && funBridgeEnabled,
      staleTime: 60_000,
    },
  });

  const hasNoWalletBalance = ausdBalance === 0n;
  const shouldShowBridgeAlert = funBridgeEnabled && isAuth && isWalletDataLoaded && hasNoExchangeBalance && hasNoWalletBalance;

  return shouldShowBridgeAlert;
}
